import React from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import CardActionArea from '@material-ui/core/CardActionArea';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Chip from '@material-ui/core/Chip';
import Button from '@material-ui/core/Button';
import { Link as RouterLink } from 'react-router-dom';
import { newsExcerpt, newsPath, newsTitle, newsThumbnail } from '../utils/news';

const useStyles = makeStyles((theme) => ({
    cardGrid: {
        paddingBottom: theme.spacing(6),
    },
    card: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 24,
        boxShadow: '0 20px 45px rgba(16,55,92,0.08)',
        background: 'linear-gradient(180deg, #ffffff 0%, #f6f8fb 100%)',
        border: '1px solid rgba(16,55,92,0.08)',
    },
    cardActionArea: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        alignItems: 'stretch',
    },
    mediaWrapper: {
        position: 'relative',
    },
    chip: {
        position: 'absolute',
        top: theme.spacing(2),
        left: theme.spacing(2),
        backgroundColor: 'rgba(16,55,92,0.85)',
        color: '#fff',
        fontWeight: 600,
    },
    cardMedia: {
        display: 'block',
        width: '100%',
        height: 215,
        objectFit: 'cover',
    },
    cardContent: {
        flexGrow: 1,
        paddingBottom: theme.spacing(2),
    },
    excerpt: {
        color: theme.palette.text.secondary,
        marginTop: theme.spacing(1),
        display: '-webkit-box',
        WebkitLineClamp: 5,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        minHeight: 120,
    },
    cardActions: {
        padding: theme.spacing(2, 3, 3),
    },
    actionButton: {
        borderRadius: 12,
        fontWeight: 600,
    }
}));

export default function News(props: any): JSX.Element {
    const classes = useStyles();
    const { posts } = props;

    return (
        <>
            <Container className={classes.cardGrid} maxWidth="xl">
                <Grid container spacing={4}>
                    {posts.map((card: any, idx: number) => (
                        <Grid item key={idx} xs={12} sm={6} md={3}>
                            <Card className={classes.card}>
                                <CardActionArea className={classes.cardActionArea} component={RouterLink} to={newsPath(card)}>
                                    <div className={classes.mediaWrapper}>
                                        <Chip label={card.date} size="small" className={classes.chip} />
                                        <img
                                            className={classes.cardMedia}
                                            src={newsThumbnail(card)}
                                            alt={`Gambar artikel: ${newsTitle(card)}`}
                                            loading="lazy"
                                            decoding="async"
                                            width="640"
                                            height="400"
                                        />
                                    </div>
                                    <CardContent className={classes.cardContent}>
                                        <Typography variant="subtitle2" component="p" color="textSecondary">
                                            Berita Terbaru
                                        </Typography>
                                        <Typography variant="h6" component="h2">
                                            {newsTitle(card)}
                                        </Typography>
                                        <Typography variant="body2" className={classes.excerpt}>
                                            {newsExcerpt(card, 168) || 'Konten akan segera tersedia.'}
                                        </Typography>
                                    </CardContent>
                                </CardActionArea>
                                <CardActions className={classes.cardActions}>
                                    <Button
                                        component={RouterLink}
                                        to={newsPath(card)}
                                        color="primary"
                                        variant="contained"
                                        fullWidth
                                        className={classes.actionButton}
                                    >
                                        Baca Selengkapnya
                                    </Button>
                                </CardActions>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </>
    );
}
